import { FC, ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';

type WebEDIHeaderConfig = {
  title: string;
  description?: string;
  spacing: 'small' | 'medium';
  action?: ReactNode;
};

type WebEDISectionProps = {
  children: ReactNode;
  header?: WebEDIHeaderConfig;
};
export const WebEDISection: FC<WebEDISectionProps> = ({ children, header }) => {
  return (
    <section aria-label={header?.title} className="relative">
      {header ? (
        <div className={cn(header.spacing === 'small' ? 'mb-4' : 'mb-6', 'flex flex-col gap-2 text-xs')}>
          <div className="relative flex items-center justify-between">
            {header.action ? (
              <div aria-hidden="true" className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200" />
              </div>
            ) : null}
            {header.title ? (
              <h1 className="relative bg-white pr-3 font-medium tracking-wider text-gray-600 uppercase">
                {header.title}
              </h1>
            ) : null}
            {header.action ? <div className="relative bg-white">{header.action}</div> : null}
          </div>
          {header.description ? <p className="text-sm text-gray-500">{header.description}</p> : null}
        </div>
      ) : null}
      <div>{children}</div>
    </section>
  );
};
